'use strict';

Object.defineProperty(exports, "__esModule", {
		value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _reactRedux = require('react-redux');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConclusionMenu = (_dec = (0, _reactRedux.connect)(function (state, props) {
		return { currentLanguage: state.language.lang };
}, {}), _dec(_class = (_temp = _class2 = function (_Component) {
		(0, _inherits3.default)(ConclusionMenu, _Component);

		function ConclusionMenu(props, context) {
				(0, _classCallCheck3.default)(this, ConclusionMenu);
				return (0, _possibleConstructorReturn3.default)(this, (ConclusionMenu.__proto__ || (0, _getPrototypeOf2.default)(ConclusionMenu)).call(this, props));
		}

		(0, _createClass3.default)(ConclusionMenu, [{
				key: 'render',
				value: function render() {

						var otherCases = this.props.otherCases;
						var strings = this.props.strings;

						return _react2.default.createElement(
								'nav',
								{ className: 'conclusionSubmenu' },
								_react2.default.createElement(
										'ul',
										null,
										_react2.default.createElement(
												'li',
												{ className: 'box-1' },
												_react2.default.createElement(
														_reactRouter.Link,
														{ to: "/" + this.context.project + "/" + this.props.currentLanguage + otherCases[0].url, draggable: 'false', onClick: this.props.resetCase },
														_react2.default.createElement(
																'div',
																{ className: 'box-title' },
																_react2.default.createElement(
																		'p',
																		{ className: 'title' },
																		otherCases[0].nameMenu
																),
																_react2.default.createElement(
																		'p',
																		{ className: 'subtitle' },
																		otherCases[0].title
																)
														),
														_react2.default.createElement('img', { draggable: 'false', src: this.context.baseUrl + otherCases[0].imageMenu, className: ' box-cover' })
												)
										),
										_react2.default.createElement(
												'li',
												{ className: 'box-2' },
												_react2.default.createElement(
														_reactRouter.Link,
														{ to: "/" + this.context.project + "/" + this.props.currentLanguage + otherCases[1].url, draggable: 'false', onClick: this.props.resetCase },
														_react2.default.createElement(
																'div',
																{ className: 'box-title' },
																_react2.default.createElement(
																		'p',
																		{ className: 'title' },
																		otherCases[1].nameMenu
																),
																_react2.default.createElement(
																		'p',
																		{ className: 'subtitle' },
																		otherCases[1].title
																)
														),
														_react2.default.createElement('img', { draggable: 'false', src: this.context.baseUrl + otherCases[1].imageMenu, className: ' box-cover' })
												)
										),
										_react2.default.createElement(
												'li',
												{ className: 'box-3' },
												_react2.default.createElement(
														_reactRouter.Link,
														{ to: "/" + this.context.project + "/" + this.props.currentLanguage + '/quien-hace-estas-verificaciones/', draggable: 'false' },
														_react2.default.createElement(
																'div',
																{ className: 'box-title' },
																_react2.default.createElement(
																		'p',
																		{ className: 'title' },
																		strings.subMenu.text1
																),
																_react2.default.createElement(
																		'p',
																		{ className: 'subtitle' },
																		strings.subMenu.text2
																)
														),
														_react2.default.createElement('img', { draggable: 'false', src: this.context.baseUrl + '' + strings.subMenu.imgSrc, className: ' box-cover' })
												)
										)
								)
						);
				}
		}]);
		return ConclusionMenu;
}(_react.Component), _class2.contextTypes = {
		baseUrl: _react.PropTypes.string.isRequired,
		project: _react.PropTypes.string.isRequired
}, _class2.propTypes = {
		currentCase: _react.PropTypes.string.isRequired,
		otherCases: _react.PropTypes.array.isRequired
}, _temp)) || _class);
exports.default = ConclusionMenu;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Util/ConclusionMenu.js
// module id = 806
// module chunks = 0